module.exports = __webpack_public_path__ + "static/media/14-aermel_kittel_schuhe.35000785.jpg";